import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './FooterCopyright.scss';
const FooterCopyright = ({ className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", null, t('siteFooter.copyright', {
        year: new Date().getFullYear()
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['separator']
    }), /*#__PURE__*/ React.createElement("div", null, t('siteFooter.allRightsReserved')));
};
FooterCopyright.displayName = 'FooterCopyright';
export default /*#__PURE__*/ React.memo(FooterCopyright);

//# sourceMappingURL=FooterCopyright.js.map